import { createTheme } from "@mui/material/styles";


const theme = createTheme({
    palette: {
        primary: {
            main: '#5E7A60',   // Sage green brand color
        },
        secondary: {
            main: '#8C7862',   // Muted clay / warm sand
        },

    },

    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '10px', // Set border radius
                    },
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                root: {
                    zIndex: 1302,
                }
            }
        },
      
    },
    typography: {


        fontFamily: [
            'Inter',
            'sans-serif',
        ].join(','),

        h5: {
            color: '#000000',
        },


        body1: {
            color: '#78716C',
        },
        span: {
            color: '#78716C',
        }
    },
});

export default theme;
